import { render, staticRenderFns } from "./chuanxinxi.vue?vue&type=template&id=38601204&scoped=true"
import script from "./chuanxinxi.vue?vue&type=script&lang=js"
export * from "./chuanxinxi.vue?vue&type=script&lang=js"
import style0 from "./chuanxinxi.vue?vue&type=style&index=0&id=38601204&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38601204",
  null
  
)

export default component.exports